import { Controller } from '@hotwired/stimulus';

const SEARCH_DEBOUNCE_MS = 500;

export default class extends Controller {
  static targets = ['overlay', 'statusAll', 'statusOption'];

  disconnect() {
    clearTimeout(this.debounceTimer);
  }

  submit() {
    clearTimeout(this.debounceTimer);
    this.showOverlay();
    this.element.requestSubmit();
  }

  debouncedSubmit() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.submit(), SEARCH_DEBOUNCE_MS);
  }

  statusChange(event) {
    if (this.hasStatusAllTarget && event.target === this.statusAllTarget) {
      if (this.statusAllTarget.checked) {
        this.statusOptionTargets.forEach((option) => {
          option.checked = false;
        });
      }
    } else if (this.hasStatusAllTarget) {
      this.statusAllTarget.checked = false;
      if (!this.statusOptionTargets.some((option) => option.checked)) {
        this.statusAllTarget.checked = true;
      }
    }
    this.debouncedSubmit();
  }

  showOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.style.display = 'flex';
    }
  }
}
